import * as React from 'react';
import { useTheme } from '../theme';
import { BaseButton } from '../BaseComponents';

import { useTranslation } from 'react-i18next';
import { useConfig } from '../context';

interface Props {
	onClick: () => void;
}

const Page404: React.FC<Props> = ({ onClick }) => {
	const css = useTheme('Page404').Page404;
	const { t } = useTranslation('Page404');

	const {
		global: { page404Url }
	} = useConfig();

	if (page404Url) {
		window.location.href = page404Url;

		return null;
	}

	return (
		<div className={css.wrapper}>
			<div className={css.content}>
				<h3 className={css.error__description}>{t('Destination unknown')}</h3>
				<h1 className={css.error__code}>{t('PAGE NOT FOUND')}</h1>

				<BaseButton variant="action" className={css.button} onClick={onClick}>
					{t('Take me home')}
				</BaseButton>
			</div>
		</div>
	);
};

export default Page404;
